module.exports = __webpack_public_path__ + "static/media/usersActive.eb72ec69.svg";